import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a850d52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "a product product-list-item" }
const _hoisted_2 = { class: "product-list-item__image-wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "product-list-item__info" }
const _hoisted_5 = { class: "rating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rating__title" }, "Rating:", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-star rating__icon" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "rating__value" }
const _hoisted_9 = { class: "product-char" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "product-char__name" }, "Category", -1 /* HOISTED */))
const _hoisted_11 = { class: "product-char__value" }
const _hoisted_12 = { class: "product-char" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "product-char__name" }, "Brand", -1 /* HOISTED */))
const _hoisted_14 = { class: "product-char__value" }
const _hoisted_15 = { class: "product-char" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "product-char__name" }, "Description", -1 /* HOISTED */))
const _hoisted_17 = { class: "product-char__value" }
const _hoisted_18 = { class: "product-list-item__actions" }
const _hoisted_19 = { class: "price product-list-item__price" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "price__actual product-list-item__price-value" }
const _hoisted_23 = { class: "price__fixed product-list-item__price-value" }
const _hoisted_24 = {
  key: 0,
  class: "icon-cart-plus cart-btn__icon"
}
const _hoisted_25 = {
  key: 1,
  class: "icon-cart-ok cart-btn__icon"
}
const _hoisted_26 = { class: "cart-btn__text" }

import { IProduct } from '@/services';
import { useProductInfo } from '@/composables';
import { computed } from 'vue';
import { RouteNames } from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductListItem',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: IProduct;
};



const { inCart, toggleProduct } = useProductInfo(props.product);

const cartBtnClass = computed(() => {
  return inCart.value ? 'cart-btn_in-cart' : '';
});

function cartBtnClick(e: Event) {
  e.preventDefault();
  toggleProduct();
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "product__image",
        src: __props.product.thumbnail,
        loading: "lazy"
      }, null, 8 /* PROPS */, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_RouterLink, {
        to: { name: _unref(RouteNames).product, params: { id: `${__props.product.id}` } },
        class: "a product__heading product-list-item__heading"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.product.title), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(__props.product.rating), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, _toDisplayString(__props.product.category), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("span", _hoisted_14, _toDisplayString(__props.product.brand), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("span", _hoisted_17, _toDisplayString(__props.product.description), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        (__props.product.discountPercentage === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, " $" + _toDisplayString(__props.product.actualPrice.toFixed(2)), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, "$" + _toDisplayString(__props.product.actualPrice.toFixed(2)), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_23, "$" + _toDisplayString(__props.product.price.toFixed(2)), 1 /* TEXT */)
            ]))
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["btn cart-btn", _unref(cartBtnClass)]),
        onClick: cartBtnClick
      }, [
        (!_unref(inCart))
          ? (_openBlock(), _createElementBlock("i", _hoisted_24))
          : (_openBlock(), _createElementBlock("i", _hoisted_25)),
        _createElementVNode("span", _hoisted_26, _toDisplayString(!_unref(inCart) ? 'Add to cart' : 'Added!'), 1 /* TEXT */)
      ], 2 /* CLASS */)
    ])
  ]))
}
}

})